import { render, staticRenderFns } from "./DisableCategoryItemModal.vue?vue&type=template&id=015d053c&scoped=true"
import script from "./DisableCategoryItemModal.vue?vue&type=script&lang=ts"
export * from "./DisableCategoryItemModal.vue?vue&type=script&lang=ts"
import style0 from "./DisableCategoryItemModal.vue?vue&type=style&index=0&id=015d053c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015d053c",
  null
  
)

export default component.exports